<template>
  <v-app-bar
    class="transparent fixed"
    height="84px"
    app
    :dark="isDark"
    color="black"
    flat
    :absolute="!isHome"
    :hide-on-scroll="isHome"
    ref="top-nav"
  >
    <v-spacer />
    <img
      class="clickable"
      :src="isDark ? logo : logoDark"
      height="25px"
      @click="goHome"
    />
    <v-spacer />
    <v-spacer />
    <router-link
      class="ma-8 link"
      v-bind:class="{ 'color-black': !isDark, 'color-white': isDark }"
      to="/"
      >Home</router-link
    >
    <router-link
      class="ma-8 link"
      v-bind:class="{ 'color-black': !isDark, 'color-white': isDark }"
      to="/wwo"
      >What We Offer</router-link
    >
    <router-link
      class="ma-8 link"
      v-bind:class="{ 'color-black': !isDark, 'color-white': isDark }"
      to="/insights"
      >Insights</router-link
    >
    <router-link
      class="ma-8 link"
      v-bind:class="{ 'color-black': !isDark, 'color-white': isDark }"
      to="/about"
      >About</router-link
    >

    <!-- <router-link
      class="ma-8 link"
      v-bind:class="{ 'color-black': !isDark, 'color-white': isDark }"
      to="/people"
    >People</router-link>-->
    <router-link
      class="ma-8 link"
      v-bind:class="{ 'color-black': !isDark, 'color-white': isDark }"
      to="/contact"
      >Contact</router-link
    >

    <router-link
      class="ma-8 link"
      v-bind:class="{ 'color-black': !isDark, 'color-white': isDark }"
      to="/datavoucher"
    >
      <v-btn outlined> Data Voucher </v-btn>
    </router-link>
    <v-spacer />
  </v-app-bar>
</template>

<script>
import logo from "../assets/dmlogo.png";
import logoBlack from "../assets/logo_black.png";

export default {
  computed: {
    isDark() {
      let path = this.$route.path;
      return path === "/" || path === "/about" || path.includes("/news");
    },
    isHome() {
      let path = this.$route.path;
      return path === "/";
    },
  },
  data: () => ({
    logo: logo,
    logoDark: logoBlack,
  }),
  methods: {
    goHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style>
.transparent {
  background-color: transparent !important;
  border: none !important;
  z-index: 3 !important;
}

.fixed {
  position: fixed;
}

.link {
  transition: 0.3s ease-in-out;
}

.link:hover {
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: 0.3s ease-in-out;
}

@media only screen and (max-width: 880px) {
  .transparent {
    visibility: hidden;
  }
}
</style>
